import { useState } from 'react';
import { fetchSystemCSV } from '@api/system';
import { useSelector } from 'react-redux';
import { useAlert } from '@hooks/useAlert';
import type { RootState } from '@features/redux/store';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Button } from '@components/design-system';

export const ExportSystems = ({ params, type }: { type: string; params: Record<string, string> }) => {
    const { IdToken } = useSelector((state: RootState) => state.auth);
    const [loading, setLoading] = useState(false);

    const { setAlert } = useAlert();

    const downloadCSV = async () => {
        setLoading(true);
        const data = await fetchSystemCSV(IdToken!, { ...params, type }).catch((err) => {
            setAlert(err.message, 'error');
            setLoading(false);
        });

        if (!data) {
            setLoading(false);
            return;
        }

        const csvData = `data:text/csv;base64,${btoa(unescape(encodeURIComponent(data)))}`;

        const link = document.createElement('a');
        link.setAttribute('href', csvData);
        link.setAttribute('download', `${type}-systems.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
    };

    return (
        <Button
            variant='secondary'
            size='small'
            startIcon={<FileDownloadOutlinedIcon sx={{ fontSize: 18 }} />}
            onClick={downloadCSV}
            loading={loading}>
            Export
        </Button>
    );
};
